import React from "react";
import { Button } from "../ui/button";
import { Link } from "react-router-dom";

const QuickActionCard = ({
  handleClick,
  buttonText,
  icon,
  isLink = false,
  buttonLink = "",
  onDraftClick
}) => {
  return (
    <div className="relative bg-card rounded-2xl border border-border p-6 w-full">
      <div className="flex flex-col justify-start items-start gap-4">
        <div className="text-foreground text-2xl leading-normal font-semibold">
          Quick Actions
        </div>

        {/* Primary Submit Button */}
        {isLink ? (
          <Button
            asChild
            className="bg-button-coloured rounded-lg text-button-coloured-foreground w-full flex justify-center items-center py-2"
          >
            <Link to={buttonLink}>{buttonText}</Link>
          </Button>
        ) : (
          <Button
            className="bg-button-coloured rounded-lg text-button-coloured-foreground w-full flex justify-center items-center py-2 gap-2"
            onClick={handleClick}
          >
            {icon}
            <p className="font-sm">{buttonText}</p>
          </Button>
        )}

        {/* SAVE AS DRAFT BUTTON */}
        <Button
          className="bg-button-generic rounded-lg text-button-generic-foreground w-full flex justify-center items-center text-sm py-2 hover:bg-button-generic/80 gap-2"
          onClick={onDraftClick}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            className="stroke-current"
          >
            <path
              d="M2.66659 5.33333V12.6667C2.66659 13.0203 2.80706 13.3594 3.05711 13.6095C3.30716 13.8595 3.6463 14 3.99992 14H11.9999C12.3535 14 12.6927 13.8595 12.9427 13.6095C13.1928 13.3594 13.3333 13.0203 13.3333 12.6667V5.33333M6.66658 8H9.33325M1.99992 2H13.9999C14.3681 2 14.6666 2.29848 14.6666 2.66667V4.66667C14.6666 5.03486 14.3681 5.33333 13.9999 5.33333H1.99992C1.63173 5.33333 1.33325 5.03486 1.33325 4.66667V2.66667C1.33325 2.29848 1.63173 2 1.99992 2Z"
              strokeWidth="1.33"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p className="text-sm">Save as Draft</p>
        </Button>
      </div>
    </div>
  );
};

export default QuickActionCard;
